import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/DiscoveryPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BottomNav.tsx");
